// @flow
import React from "react";
import type { IconProps } from "../";

type Props = {
  ...IconProps,
  className?: string,
  onClick?: () => void
};

export default function DepositSuccess({ width = "61px", ...props }: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 61 61"
      width={width}
      {...props}
    >
      <path
        fill="#fedb41"
        d="M30.619,0A30.606,30.606,0,0,0,0,30.381,30.81,30.81,0,0,0,30.619,61a30.5,30.5,0,0,0,0-61Z"
      />
      <path
        fill="#fc3"
        d="M287.381,30.381A30.606,30.606,0,0,1,257,61V0A30.4,30.4,0,0,1,287.381,30.381Z"
        transform="translate(-226.381)"
      />
      <path
        fill="#fea832"
        d="M83.471,60A23.352,23.352,0,1,0,106.7,83.232,23.483,23.483,0,0,0,83.471,60Z"
        transform="translate(-52.852 -52.852)"
      />
      <path
        fill="#fe9923"
        d="M280.232,83.232A23.483,23.483,0,0,1,257,106.7V60A23.277,23.277,0,0,1,280.232,83.232Z"
        transform="translate(-226.381 -52.852)"
      />
      <path
        fill="#fedb41"
        d="M192.748,134.3h-1.787v-7.148h1.787a1.77,1.77,0,0,1,1.787,1.787,1.787,1.787,0,0,0,3.574,0,5.354,5.354,0,0,0-5.361-5.361h-1.787v-1.787a1.787,1.787,0,0,0-3.574,0v1.787h-2.025A5.354,5.354,0,0,0,180,128.936v3.574a5.354,5.354,0,0,0,5.361,5.361h2.025v7.387h-2.025a1.77,1.77,0,0,1-1.787-1.787,1.787,1.787,0,0,0-3.574,0,5.354,5.354,0,0,0,5.361,5.361h2.025v1.787a1.787,1.787,0,0,0,3.574,0v-1.787h1.787a5.354,5.354,0,0,0,5.361-5.361v-3.812A5.354,5.354,0,0,0,192.748,134.3Zm-5.361,0h-2.025a1.77,1.77,0,0,1-1.787-1.787v-3.574a1.77,1.77,0,0,1,1.787-1.787h2.025Zm7.148,9.174a1.77,1.77,0,0,1-1.787,1.787h-1.787v-7.387h1.787a1.77,1.77,0,0,1,1.787,1.787Z"
        transform="translate(-158.555 -105.703)"
      />
      <path
        fill="#fc3"
        d="M260.574,134.3h-1.787v-7.148h1.787a1.77,1.77,0,0,1,1.787,1.787,1.787,1.787,0,0,0,3.574,0,5.354,5.354,0,0,0-5.361-5.361h-1.787v-1.787A1.724,1.724,0,0,0,257,120v32.406a1.724,1.724,0,0,0,1.787-1.787v-1.787h1.787a5.354,5.354,0,0,0,5.361-5.361v-3.812A5.354,5.354,0,0,0,260.574,134.3Zm1.787,9.174a1.77,1.77,0,0,1-1.787,1.787h-1.787v-7.387h1.787a1.77,1.77,0,0,1,1.787,1.787Z"
        transform="translate(-226.381 -105.703)"
      />
    </svg>
  );
}



// WEBPACK FOOTER //
// ./src/components/Icons/Announcements/DepositSuccess.js